import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/trophy.svg'
import _imports_1 from '@/assets/img/iDays_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-24a5d081"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ranking" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "idaysLogo"
}, null, -1))
const _hoisted_5 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_6 = {
  key: 0,
  class: "text ms-1"
}
const _hoisted_7 = {
  key: 1,
  class: "text ms-1"
}
const _hoisted_8 = { class: "rankingTable text-start mt-5" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "ps-2" }, null, -1))
const _hoisted_10 = { class: "pe-4" }
const _hoisted_11 = ["id"]
const _hoisted_12 = { class: "ps-2" }
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = { class: "me-2" }
const _hoisted_15 = { class: "d-block" }
const _hoisted_16 = { class: "pe-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_localized_text, {
        localizedKey: "app_Classifica",
        text: "Classifica",
        type: "h1",
        class: "my-3"
      }),
      _hoisted_4,
      _createVNode(_component_localized_text, {
        localizedKey: "app_La tua scalata verso i biglietti: dacci dentro!",
        text: "La tua scalata verso i biglietti: dacci dentro!",
        class: "text my-4",
        type: "p"
      }),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_localized_text, {
          localizedKey: "app_Posizione attuale:",
          text: "Posizione attuale:",
          class: "text"
        }),
        (_ctx.myPosition > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.myPosition) + "°", 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_7, "--"))
      ]),
      (_ctx.myPosition > 0)
        ? (_openBlock(), _createBlock(_component_localized_text, {
            key: 0,
            localizedKey: "app_Visualizza",
            text: "Visualizza >",
            class: "fs_12 brandOppositeColor fw_800 d-block mt-1 mb-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToMyPosition()))
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("table", _hoisted_8, [
      _createElementVNode("thead", null, [
        _hoisted_9,
        _createElementVNode("th", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "app_Player",
            text: "Player"
          })
        ]),
        _createElementVNode("th", _hoisted_10, [
          _createVNode(_component_localized_text, {
            localizedKey: "app_Time",
            text: "Time"
          })
        ]),
        _createElementVNode("th", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "app_Pt.",
            text: "Pt."
          })
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ranking, (rank, index) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: index,
            class: _normalizeClass(_ctx.checkIfIsMe(rank.userIdentifier) ? 'isMe' : ''),
            id: rank.userIdentifier
          }, [
            _createElementVNode("td", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(index + 1), 1),
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.checkIfIsMe(rank.userIdentifier) ? 'brandColor' : 'brandOppositeColor')
                }, "/", 2)
              ])
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("span", _hoisted_15, _toDisplayString(rank.name), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.getSurnameTruncate(rank.surname)), 1)
            ]),
            _createElementVNode("td", _hoisted_16, [
              _createElementVNode("span", null, _toDisplayString(_ctx.getTimerValue(rank.totalTime)), 1)
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("span", null, _toDisplayString(rank.totalPoints), 1)
            ])
          ], 10, _hoisted_11))
        }), 128))
      ])
    ])
  ]))
}